import { Component, OnChanges } from '@angular/core'

import { QuestionTypeView, QuestionViewService } from '..'
import { TextQuestionAutosaver, ExamState } from '../../../../core/services'

@Component({
  selector: 'mp-essay-question-view',
  templateUrl: './essay-question-view.html',
  styleUrls: ['./essay-question-view.scss']
})
export class EssayQuestionViewComponent extends QuestionTypeView implements OnChanges {

  public get textareaPrompt() {
    return this.form.getPrompt('essay_text')
  }

  public get textareaFormControl() {
    return this.formGroup.get('essay_text')
  }

  public constructor(
     _questionViewService: QuestionViewService,
     private _textQuestionAutosaver: TextQuestionAutosaver,
     private _examState: ExamState
  ) { super(_questionViewService) }

  public ngOnChanges() {
    if(this._examState.testExecution) {
      this._textQuestionAutosaver.autoSave(this.textareaFormControl.valueChanges, this.question, this._examState.testExecution)
      .subscribe()
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/angular/components/question-view/essay-question-view/essay-question-view.component.ts